export const START_SINCRONIZZA_ALIAS = 'START_SINCRONIZZA_ALIAS';

/**
 * Get persona telefoni.
 * @function startRipristinaDefaults
 * @param {Object} data Data.
 * @returns {Object} Get querystringsearch results action.
 */
export function startSincronizzaAlias(path, data, subrequest, page) {
  return {
    type: START_SINCRONIZZA_ALIAS,
    path,
    request: {
      op: 'get',
      path: `${path}/@sincronizzaAlias`,
    },
  };
}
